import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';

// Функция для выполнения GET-запроса и получения информации о новой версии
export async function getLatestVersionInfo(store) {
  const version = store.getters.currentVersion;
  const { locale } = i18n;
  try {
    const response = await axios.get('/software', {
      params: {
        version,
        locale,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(i18n.t('toast.errorFetchingNewVersionInfo'), error.message);
  }
  return null;
}
